export const searchSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "url": "https://www.youtube.com/@OlympiadPracticeApp",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.youtube.com/@OlympiadPracticeApp/search?query={search_term_string}",
    "query-input": "required name=search_term_string"
  }
}
export default searchSchema;